import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import Container from './components/Container';
import { NotFound } from '@chiroup/components';

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <SentryRoutes>
          <Route path="/:path/*" element={<Container />} />
          <Route path="*" element={<NotFound />} />
        </SentryRoutes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
